import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Chip,
    Button,
} from "@mui/material";
import { Delete } from "@mui/icons-material";
import React, { useEffect, useState, useCallback } from "react";
import { getOpenOrders, cancelOrders } from "../api/apiCalls";

const PopperOpenOrders = ({ name, timeout }) => {
    const [openOrders, setOpenOrders] = useState([]);

    const sendCancelOrders = async (order_id, instrument_name) => {
        // console.log(order_id, instrument_name);
        await cancelOrders(order_id, instrument_name);
        await getOrders(instrument_name);
        timeout.current = 0;
    };

    const getOrders = useCallback(async () => {
        // console.log("PopperOpenOrder-FetchData");

        const res = await getOpenOrders(name);
        res.sort((a, b) => a.price - b.price);
        setOpenOrders(res);
    }, [name]);

    useEffect(() => {
        getOrders();
    }, [getOrders, openOrders]);

    return (
        <>
            <TableContainer component={Paper} sx={{ maxWidth: 400 }}>
                <Table size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" width="80px">
                                Side
                            </TableCell>
                            <TableCell align="right">Qty</TableCell>
                            <TableCell align="right">Price</TableCell>
                            <TableCell align="center">Action</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {openOrders.map((order) => (
                            <TableRow key={order.order_id}>
                                <TableCell
                                    align="center"
                                    component="th"
                                    scope="row"
                                >
                                    {order.side === "BUY" ? (
                                        <Chip
                                            label={order.side}
                                            sx={{ width: "60px" }}
                                            color="success"
                                            size="small"
                                        />
                                    ) : (
                                        <Chip
                                            label={order.side}
                                            sx={{ width: "60px" }}
                                            color="error"
                                            size="small"
                                        />
                                    )}
                                </TableCell>
                                <TableCell align="right">
                                    {order.quantity}
                                </TableCell>
                                <TableCell align="right">
                                    {order.price}
                                </TableCell>
                                <TableCell align="center">
                                    <Button
                                        onClick={() =>
                                            sendCancelOrders(
                                                order.order_id,
                                                order.instrument_name
                                            )
                                        }
                                    >
                                        <Delete
                                            color="error"
                                            sx={{
                                                height: "20px",
                                                width: "20px",
                                            }}
                                        />
                                    </Button>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
};
export default PopperOpenOrders;
